import { useQuery, keepPreviousData } from '@tanstack/react-query';
import { cart } from '@api/apis';
import { IHash } from 'types/base.types';
import { queryClient } from '@integrations/reactquery';
import { isValidNonEmptyArray } from '@utils/array';

/* Keys */
import { cartQueryKeys } from './queries.keys';

import { Cart } from 'types/cart.types';
import { Sku } from 'types/sku.types';
/**
 * Note: Pass in options to override defaults, if needed.
 * @params: returned:
 * data, isLoading, isError, error, status, isFetching, refetch
 */
interface ICartItemPride {
  item: any;
  queryKey?: string;
  options?: IHash<any>;
  sku: Sku;
}

const useCartQueryItemprice = ({ item, sku, options = {} }: ICartItemPride) => {
  const cartCache = (queryClient.getQueryData(cartQueryKeys.all) as Cart) || {};
  const inHome = cartCache && !cartCache.remote && !!cartCache.items?.length && sku.remoteSavings;
  /* Default Query Options */
  const defaultOptions = {
    enabled: Boolean(item && item.updated && item.skuId && isValidNonEmptyArray(Object.keys(cartCache))),
    placeholderData: keepPreviousData,
  };

  const mergedOptions = { ...defaultOptions, ...options };

  return useQuery({
    queryKey: cartQueryKeys.itemPrice(item),

    queryFn: async () => {
      const { data } = await cart.itemPrice({ item, inHome });

      return {
        totalPrice: data?.price || '',
        breakdown: data?.breakdown || {},
      };
    },
    ...mergedOptions,
  });
};

export default useCartQueryItemprice;
